import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ExclamationCircleIcon, Link, Text, themeVars } from '@eds-web/react';
import { useSelector } from 'react-redux';

import { selectConfigState } from '../selectors/config.selector';
import { StyledGatedContent } from './access/AgeGated.style';

export const UserGated: React.FC<{ age: number }> = ({ age }) => {
    const { t } = useTranslation();
    const supportLink = '/competitive/support';
    return (
        <StyledGatedContent>
            <div className="alert-icon">
                <ExclamationCircleIcon size={64} color={'warning'} />
            </div>
            <Text variant={'headingLG'}>{t('epic.esport.content_gate.title.v2', { age })}</Text>
            <Text
                style={{ color: themeVars.color.transparent.light['065'] }}
                variant={'paragraphMD'}
            >
                <Trans
                    components={{
                        a: <Link target={'_blank'} href={supportLink} />
                    }}
                    i18nKey={'epic.esport.content_gate.info.v2'}
                    values={{ age }}
                />
            </Text>
        </StyledGatedContent>
    );
};

export const UserCabinedMode = () => {
    const { t } = useTranslation();
    const configState = useSelector(selectConfigState);
    const accountPortalUrl = configState?.accountPortal;
    return (
        <StyledGatedContent>
            <div className="alert-icon">
                <ExclamationCircleIcon size={64} color={'warning'} />
            </div>
            <Text variant={'headingLG'}>{t('epic.esport.content_gate.title')}</Text>
            <Text
                style={{ color: themeVars.color.transparent.light['065'] }}
                variant={'paragraphMD'}
                dangerouslySetInnerHTML={{
                    __html: t('epic.esport.cabined_mode.info.v2', { accountPortalUrl })
                }}
            />
        </StyledGatedContent>
    );
};

export const RedeemError = () => {
    const configState = useSelector(selectConfigState);
    const { t } = useTranslation();
    const supportUrl = configState?.supportUrl;
    const supportSiteName = t('epic.common.competitive');
    return (
        <StyledGatedContent>
            <div className="alert-icon">
                <ExclamationCircleIcon size={64} color={'warning'} />
            </div>
            <Text variant={'headingLG'}>{t('epic.esport.entitlement.reason.title')}</Text>
            <Text
                style={{ color: themeVars.color.transparent.light['065'] }}
                variant={'paragraphMD'}
            >
                {t('epic.esport.entitlement.info')}
                <ul>
                    <li>{t('epic.esport.entitlement.reason.verifying')}</li>
                    <li>{t('epic.esport.entitlement.reason.account')}</li>
                    <li>{t('epic.esport.entitlement.reason.noId')}</li>
                </ul>
            </Text>
            <Text
                style={{ color: themeVars.color.transparent.light['065'] }}
                variant={'paragraphMD'}
                dangerouslySetInnerHTML={{
                    __html: t('errors.com.epicgames.ecommerce.payout.loseEntitlement.v2', {
                        supportUrl,
                        supportSiteName
                    })
                }}
            />
        </StyledGatedContent>
    );
};
